/**
 * Grouped Device Filter — Enterprise Theme
 *
 * Intercepts the native facet filter for custom.device and renders
 * values as three-level collapsible groups: Brand → Series → Model.
 * Grouping is driven entirely by the DEVICE_MAPPINGS object below —
 * no fragile prefix detection. Any unmapped value falls back to flat/ungrouped.
 *
 * Files involved:
 *   - assets/grouped-device-filter.js  ← this file
 *   - assets/grouped-device-filter.css
 *   - theme.liquid (loads both files)
 */

(function () {
  'use strict';

  // ─── DEVICE MAPPINGS ───────────────────────────────────────────────────────
  // Add new devices here as your catalogue grows.
  // brand  = Level 1 (e.g. iPhone, Samsung, iPad, Google)
  // series = Level 2 (e.g. iPhone 17 Series, Galaxy S26 Series, iPad Air)
  // The full metafield value = Level 3 (model), rendered as-is.

  const DEVICE_MAPPINGS = {

    // ── iPHONE ────────────────────────────────────────────────────────────

    'iPhone 18 Pro':     { brand: 'iPhone', series: 'iPhone 18 Series' },
    'iPhone 18 Pro Max': { brand: 'iPhone', series: 'iPhone 18 Series' },
    'iPhone 18 Duo':     { brand: 'iPhone', series: 'iPhone 18 Series' },

    'iPhone 17':         { brand: 'iPhone', series: 'iPhone 17 Series' },
    'iPhone 17 Air':     { brand: 'iPhone', series: 'iPhone 17 Series' },
    'iPhone 17 Pro':     { brand: 'iPhone', series: 'iPhone 17 Series' },
    'iPhone 17 Pro Max': { brand: 'iPhone', series: 'iPhone 17 Series' },

    'iPhone 16':         { brand: 'iPhone', series: 'iPhone 16 Series' },
    'iPhone 16e':        { brand: 'iPhone', series: 'iPhone 16 Series' },
    'iPhone 16 Plus':    { brand: 'iPhone', series: 'iPhone 16 Series' },
    'iPhone 16 Pro':     { brand: 'iPhone', series: 'iPhone 16 Series' },
    'iPhone 16 Pro Max': { brand: 'iPhone', series: 'iPhone 16 Series' },

    'iPhone 15':         { brand: 'iPhone', series: 'iPhone 15 Series' },
    'iPhone 15 Plus':    { brand: 'iPhone', series: 'iPhone 15 Series' },
    'iPhone 15 Pro':     { brand: 'iPhone', series: 'iPhone 15 Series' },
    'iPhone 15 Pro Max': { brand: 'iPhone', series: 'iPhone 15 Series' },

    'iPhone 14':         { brand: 'iPhone', series: 'iPhone 14 Series' },
    'iPhone 14 Plus':    { brand: 'iPhone', series: 'iPhone 14 Series' },
    'iPhone 14 Pro':     { brand: 'iPhone', series: 'iPhone 14 Series' },
    'iPhone 14 Pro Max': { brand: 'iPhone', series: 'iPhone 14 Series' },

    'iPhone 13':         { brand: 'iPhone', series: 'iPhone 13 Series' },
    'iPhone 13 Mini':    { brand: 'iPhone', series: 'iPhone 13 Series' },
    'iPhone 13 Pro':     { brand: 'iPhone', series: 'iPhone 13 Series' },
    'iPhone 13 Pro Max': { brand: 'iPhone', series: 'iPhone 13 Series' },

    'iPhone 12':         { brand: 'iPhone', series: 'iPhone 12 Series' },
    'iPhone 12 Mini':    { brand: 'iPhone', series: 'iPhone 12 Series' },
    'iPhone 12 Pro':     { brand: 'iPhone', series: 'iPhone 12 Series' },
    'iPhone 12 Pro Max': { brand: 'iPhone', series: 'iPhone 12 Series' },

    'iPhone 11':         { brand: 'iPhone', series: 'iPhone 11 Series' },
    'iPhone 11 Pro':     { brand: 'iPhone', series: 'iPhone 11 Series' },
    'iPhone 11 Pro Max': { brand: 'iPhone', series: 'iPhone 11 Series' },

    'iPhone X':          { brand: 'iPhone', series: 'iPhone X Series' },
    'iPhone XR':         { brand: 'iPhone', series: 'iPhone X Series' },
    'iPhone XS':         { brand: 'iPhone', series: 'iPhone X Series' },
    'iPhone XS Max':     { brand: 'iPhone', series: 'iPhone X Series' },

    'iPhone SE2':        { brand: 'iPhone', series: 'Older iPhones' },
    'iPhone 8':          { brand: 'iPhone', series: 'Older iPhones' },
    'iPhone 7':          { brand: 'iPhone', series: 'Older iPhones' },
    'iPhone 6/6S':       { brand: 'iPhone', series: 'Older iPhones' },

    // ── SAMSUNG ───────────────────────────────────────────────────────────
    'Samsung S26':       { brand: 'Samsung', series: 'Galaxy S26 Series' },
    'Samsung S26 Plus':  { brand: 'Samsung', series: 'Galaxy S26 Series' },
    'Samsung S26 Ultra': { brand: 'Samsung', series: 'Galaxy S26 Series' },

    'Samsung S25':       { brand: 'Samsung', series: 'Galaxy S25 Series' },
    'Samsung S25 FE':    { brand: 'Samsung', series: 'Galaxy S25 Series' },
    'Samsung S25 Plus':  { brand: 'Samsung', series: 'Galaxy S25 Series' },
    'Samsung S25 Ultra': { brand: 'Samsung', series: 'Galaxy S25 Series' },

    'Samsung S24':       { brand: 'Samsung', series: 'Galaxy S24 Series' },
    'Samsung S24 FE':    { brand: 'Samsung', series: 'Galaxy S24 Series' },
    'Samsung S24 Plus':  { brand: 'Samsung', series: 'Galaxy S24 Series' },
    'Samsung S24 Ultra': { brand: 'Samsung', series: 'Galaxy S24 Series' },

    'Samsung S23':       { brand: 'Samsung', series: 'Galaxy S23 Series' },
    'Samsung S23 FE':    { brand: 'Samsung', series: 'Galaxy S23 Series' },
    'Samsung S23 Plus':  { brand: 'Samsung', series: 'Galaxy S23 Series' },
    'Samsung S23 Ultra': { brand: 'Samsung', series: 'Galaxy S23 Series' },

    'Samsung S22':       { brand: 'Samsung', series: 'Galaxy S22 Series' },
    'Samsung S22 Plus':  { brand: 'Samsung', series: 'Galaxy S22 Series' },
    'Samsung S22 Ultra': { brand: 'Samsung', series: 'Galaxy S22 Series' },

    'Samsung S21':       { brand: 'Samsung', series: 'Galaxy S21 Series' },
    'Samsung S21 FE':    { brand: 'Samsung', series: 'Galaxy S21 Series' },
    'Samsung S21 Plus':  { brand: 'Samsung', series: 'Galaxy S21 Series' },
    'Samsung S21 Ultra': { brand: 'Samsung', series: 'Galaxy S21 Series' },

    'Samsung S20':       { brand: 'Samsung', series: 'Galaxy S20 Series' },
    'Samsung S20 FE':    { brand: 'Samsung', series: 'Galaxy S20 Series' },
    'Samsung S20 Plus':  { brand: 'Samsung', series: 'Galaxy S20 Series' },
    'Samsung S20 Ultra': { brand: 'Samsung', series: 'Galaxy S20 Series' },

    'Samsung A57':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A56':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A55':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A54':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A36':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A35':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A27':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A26':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A25':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A17':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A16':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A15':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A12':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A06':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A34':       { brand: 'Samsung', series: 'Galaxy A Series' },
    'Samsung A52':       { brand: 'Samsung', series: 'Galaxy A Series' },

    'Samsung Z Fold 7':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Fold 6':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Fold 5':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Fold 4':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Flip 6':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Flip 5':  { brand: 'Samsung', series: 'Galaxy Z Series' },
    'Samsung Z Flip 4':  { brand: 'Samsung', series: 'Galaxy Z Series' },

    'Samsung Note 10':        { brand: 'Samsung', series: 'Galaxy Note Series' },
    'Samsung Note 20':        { brand: 'Samsung', series: 'Galaxy Note Series' },
    'Samsung Note 20 Ultra':  { brand: 'Samsung', series: 'Galaxy Note Series' },

    // ── GOOGLE PIXEL ──────────────────────────────────────────────────────
    'Pixel 9':           { brand: 'Google', series: 'Pixel 9 Series' },
    'Pixel 9 Pro':       { brand: 'Google', series: 'Pixel 9 Series' },
    'Pixel 9 Pro XL':    { brand: 'Google', series: 'Pixel 9 Series' },
    'Pixel 8':           { brand: 'Google', series: 'Pixel 8 Series' },
    'Pixel 8A':          { brand: 'Google', series: 'Pixel 8 Series' },
    'Pixel 8 Pro':       { brand: 'Google', series: 'Pixel 8 Series' },
    'Pixel 7':           { brand: 'Google', series: 'Pixel 7 Series' },
    'Pixel 7 Pro':       { brand: 'Google', series: 'Pixel 7 Series' },
    'Pixel 6':           { brand: 'Google', series: 'Pixel 6 Series' },
    'Pixel 6A':          { brand: 'Google', series: 'Pixel 6 Series' },
    'Pixel 6 Pro':       { brand: 'Google', series: 'Pixel 6 Series' },

    // ── iPAD ──────────────────────────────────────────────────────────────
    'iPad Air 1st Gen (2013) - 9.7"':   { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 2nd Gen (2014) - 9.7"':   { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 3rd Gen (2019) - 10.5"':  { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 4th Gen (2020) - 10.9"':  { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 5th Gen (2022) - 10.9"':  { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 11" (2024)':              { brand: 'iPad', series: 'iPad Air' },
    'iPad Air 13" (2024)':              { brand: 'iPad', series: 'iPad Air' },

    'iPad Pro 10.5" (2017)':      { brand: 'iPad', series: 'iPad Pro' },
    'iPad Pro 11" (2018-2022)':   { brand: 'iPad', series: 'iPad Pro' },
    'iPad Pro 11" M4 (2024)':     { brand: 'iPad', series: 'iPad Pro' },
    'iPad Pro 12.9" (2018-2020)': { brand: 'iPad', series: 'iPad Pro' },
    'iPad Pro 13" M4 (2024)':     { brand: 'iPad', series: 'iPad Pro' },

    'iPad Mini 1st Gen (2012)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 2nd Gen (2013)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 3rd Gen (2014)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 4th Gen (2015)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 5th Gen (2019)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 6th Gen (2021)': { brand: 'iPad', series: 'iPad Mini' },
    'iPad Mini 7th Gen (2024)': { brand: 'iPad', series: 'iPad Mini' },

    'iPad 6th Gen (2018) - 9.7"':      { brand: 'iPad', series: 'iPad Standard' },
    'iPad 7th Gen (2019) - 10.2"':     { brand: 'iPad', series: 'iPad Standard' },
    'iPad 8th Gen (2020) - 10.2"':     { brand: 'iPad', series: 'iPad Standard' },
    'iPad 9th Gen (2021) - 10.2"':     { brand: 'iPad', series: 'iPad Standard' },
    'iPad 10th Gen (2022) - 10.9"/11"': { brand: 'iPad', series: 'iPad Standard' },
    'iPad 11th Gen (2025) - 10.9"/10"': { brand: 'iPad', series: 'iPad Standard' },

  };

  // ─── DISPLAY ORDER ─────────────────────────────────────────────────────────
  // Brand and series order is derived automatically from the order things
  // are listed in DEVICE_MAPPINGS above — first time a brand/series is seen
  // while walking the object top-to-bottom sets its display position.
  // Reorder entries in DEVICE_MAPPINGS to change the filter's display order;
  // nothing else needs to be touched.
  function deriveDisplayOrder(mappings) {
    const brandOrder = [];
    const seriesOrder = {}; // brand -> ordered array of series names

    for (const key in mappings) {
      const { brand, series } = mappings[key];

      if (!brandOrder.includes(brand)) brandOrder.push(brand);

      if (!seriesOrder[brand]) seriesOrder[brand] = [];
      if (!seriesOrder[brand].includes(series)) seriesOrder[brand].push(series);
    }

    return { brandOrder, seriesOrder };
  }

  const { brandOrder: BRAND_ORDER, seriesOrder: SERIES_ORDER } = deriveDisplayOrder(DEVICE_MAPPINGS);

  // Sorts a Map's entries by a given order array. Keys not found in the
  // order array are pushed to the end, keeping their relative order.
  function sortMapEntries(map, orderArray) {
    const entries = Array.from(map.entries());
    if (!orderArray || !orderArray.length) return entries;

    return entries.sort((a, b) => {
      const iA = orderArray.indexOf(a[0]);
      const iB = orderArray.indexOf(b[0]);
      if (iA === -1 && iB === -1) return 0;
      if (iA === -1) return 1;
      if (iB === -1) return -1;
      return iA - iB;
    });
  }

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const DEVICE_LABEL_MATCH = 'device'; // case-insensitive partial match on filter heading

  // ─── FIND THE DEVICE FILTER GROUP ─────────────────────────────────────────
  function findDeviceFilterDetails() {
    const allFilterDetails = document.querySelectorAll('details.filter.disclosure');
    for (const details of allFilterDetails) {
      const labelSpan = details.querySelector('summary .font-bold');
      if (
        labelSpan &&
        labelSpan.textContent.trim().toLowerCase().includes(DEVICE_LABEL_MATCH)
      ) {
        return details;
      }
    }
    return null;
  }

  function findCheckboxList(filterDetails) {
    return filterDetails.querySelector('.filter__content ul[role="list"]');
  }

  // ─── BYPASS "SHOW MORE" TRUNCATION ────────────────────────────────────────
  // Enterprise hides items beyond a threshold using a "Show more" button.
  // We force all items visible before grouping so nothing is missed.
  function bypassShowMore(filterDetails) {
    const showMoreBtn = filterDetails.querySelector('.js-show-more, [data-show-more], .filter__show-more');
    if (showMoreBtn) showMoreBtn.click();

    const hiddenItems = filterDetails.querySelectorAll('li[hidden], li.hidden, li[style*="display: none"]');
    hiddenItems.forEach((li) => {
      li.removeAttribute('hidden');
      li.classList.remove('hidden');
      li.style.display = '';
    });

    const showMoreContainer = filterDetails.querySelector('.filter__show-more-container, .js-show-more-container');
    if (showMoreContainer) showMoreContainer.remove();
  }

  // ─── RESOLVE MAPPING ──────────────────────────────────────────────────────
  function getMapping(labelText) {
    const clean = labelText.trim().replace(/\s*\((\d+)\)\s*$/, (match, num) => {
      return parseInt(num) < 2000 ? '' : match;
    });
    return DEVICE_MAPPINGS[clean] || null;
  }

  // ─── EXTRACT PRODUCT COUNT FROM LABEL ─────────────────────────────────────
  function getCount(li) {
    const countEl = li.querySelector('label .filter__count');
    if (!countEl) return 0;
    const match = countEl.textContent.trim().match(/\((\d+)\)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  // ─── BUILD THREE-LEVEL GROUPED DOM ────────────────────────────────────────
  function buildGroupedList(originalList) {
    const items = Array.from(originalList.querySelectorAll(':scope > li'));
    if (!items.length) return;

    const brands    = new Map();
    const ungrouped = [];

    for (const li of items) {
      const checkbox = li.querySelector('input[type="checkbox"]');
      const labelEl  = li.querySelector('label .flex-auto');
      if (!checkbox || !labelEl) { ungrouped.push(li); continue; }

      const rawText  = labelEl.textContent.trim();
      const mapping  = getMapping(rawText);
      const count    = getCount(li);

      if (!mapping) { ungrouped.push(li); continue; }

      const { brand, series } = mapping;
      const isChecked = checkbox.checked;

      if (!brands.has(brand)) {
        brands.set(brand, { seriesMap: new Map(), hasChecked: false, count: 0 });
      }
      const brandEntry = brands.get(brand);
      if (isChecked) brandEntry.hasChecked = true;
      brandEntry.count += count;

      if (!brandEntry.seriesMap.has(series)) {
        brandEntry.seriesMap.set(series, { items: [], hasChecked: false, count: 0 });
      }
      const seriesEntry = brandEntry.seriesMap.get(series);
      seriesEntry.items.push(li);
      if (isChecked) seriesEntry.hasChecked = true;
      seriesEntry.count += count;
    }

    if (brands.size === 0) return;

    const newList = originalList.cloneNode(false);
    newList.setAttribute('data-gdf-grouped', 'true');

    // ── Level 1: Brand (sorted by BRAND_ORDER) ──
    const orderedBrands = sortMapEntries(brands, BRAND_ORDER);

    for (const [brand, { seriesMap, hasChecked: brandChecked, count: brandCount }] of orderedBrands) {
      const brandLi      = document.createElement('li');
      brandLi.classList.add('gdf-brand');

      const brandDetails = document.createElement('details');
      brandDetails.classList.add('gdf-brand-details');
      if (brandChecked) brandDetails.open = true;

      const brandSummary = document.createElement('summary');
      brandSummary.classList.add('gdf-brand-summary');

      const brandLabel = document.createElement('span');
      brandLabel.classList.add('gdf-brand-label');
      brandLabel.textContent = brand;
      brandSummary.appendChild(brandLabel);

      if (brandCount > 0) {
        const countSpan = document.createElement('span');
        countSpan.classList.add('gdf-count');
        countSpan.textContent = '(' + brandCount + ')';
        brandSummary.appendChild(countSpan);
      }

      const brandSelected = Array.from(seriesMap.values()).reduce(
        (acc, s) => acc + s.items.filter((li) => li.querySelector('input')?.checked).length, 0
      );
      if (brandSelected > 0) {
        const badge = document.createElement('span');
        badge.classList.add('gdf-selected-badge');
        badge.textContent = brandSelected;
        brandSummary.appendChild(badge);
      }

      const seriesList = document.createElement('ul');
      seriesList.classList.add('gdf-series-list');
      seriesList.setAttribute('role', 'list');

      // ── Level 2: Series (sorted by SERIES_ORDER[brand]) ──
      const orderedSeries = sortMapEntries(seriesMap, SERIES_ORDER[brand]);

      for (const [series, { items: seriesItems, hasChecked: seriesChecked, count: seriesCount }] of orderedSeries) {
        const seriesLi      = document.createElement('li');
        seriesLi.classList.add('gdf-series');

        const seriesDetails = document.createElement('details');
        seriesDetails.classList.add('gdf-series-details');
        if (seriesChecked) seriesDetails.open = true;

        const seriesSummary = document.createElement('summary');
        seriesSummary.classList.add('gdf-series-summary');

        const seriesLabel = document.createElement('span');
        seriesLabel.classList.add('gdf-series-label');
        seriesLabel.textContent = series;
        seriesSummary.appendChild(seriesLabel);

        if (seriesCount > 0) {
          const countSpan = document.createElement('span');
          countSpan.classList.add('gdf-count');
          countSpan.textContent = '(' + seriesCount + ')';
          seriesSummary.appendChild(countSpan);
        }

        // ── Level 3: Model (original <li> items) ──
        const modelList = document.createElement('ul');
        modelList.classList.add('gdf-model-list');
        modelList.setAttribute('role', 'list');

        for (const modelLi of seriesItems) {
          modelList.appendChild(modelLi);
        }

        seriesDetails.appendChild(seriesSummary);
        seriesDetails.appendChild(modelList);
        seriesLi.appendChild(seriesDetails);
        seriesList.appendChild(seriesLi);
      }

      brandDetails.appendChild(brandSummary);
      brandDetails.appendChild(seriesList);
      brandLi.appendChild(brandDetails);
      newList.appendChild(brandLi);
    }

    // ── Ungrouped fallback ──
    for (const li of ungrouped) {
      newList.appendChild(li);
    }

    originalList.parentNode.replaceChild(newList, originalList);
  }

  // ─── MAIN ENTRY POINT ─────────────────────────────────────────────────────
  function applyGrouping() {
    const filterDetails = findDeviceFilterDetails();
    if (!filterDetails) return;

    bypassShowMore(filterDetails);

    const list = findCheckboxList(filterDetails);
    if (!list) return;

    if (list.getAttribute('data-gdf-grouped') === 'true') return;

    buildGroupedList(list);
  }

  // ─── HOOK INTO ENTERPRISE'S AJAX LIFECYCLE ────────────────────────────────
  function init() {
    applyGrouping();

    document.addEventListener('on:facet-filters:updated', function () {
      requestAnimationFrame(function () {
        applyGrouping();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', applyGrouping);

})();